import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text, TrolleyIcon } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const LocationDetail = ({ locationDetails, availableQuantity }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const locationTextColor = locationDetails ? theme.colors.text.default : theme.colors.text.muted

  const getQuantityText = () => {
    if (availableQuantity === null || availableQuantity === undefined) {
      return t('Unidades disponibles desconocidas')
    }
    return t('{{count}} unidades disponibles', { count: availableQuantity })
  }

  const getQuantityColor = () => {
    if (availableQuantity === null || availableQuantity === undefined) {
      return theme.colors.text.muted
    }
    if (availableQuantity === 0) {
      return theme.colors.danger.default
    }
    return theme.colors.text.default
  }

  return (
    <Styles.Container>
      <Styles.LeftSection>
        <TrolleyIcon color={locationTextColor} />
        <Text type="bodyMBold" color={locationTextColor}>
          {locationDetails || t('Detalle ubicación desconocida')}
        </Text>
      </Styles.LeftSection>
      <Text type="bodyMRegular" color={getQuantityColor()}>
        {getQuantityText()}
      </Text>
    </Styles.Container>
  )
}

export default LocationDetail
